module.exports = __webpack_public_path__ + "img/box_gd.8b23ccd6.png";